import { BaseContainerModel } from '../../base-container.model';
import { bl_dgmkt_campaign_ext_RowClass } from '../../../dbschema/bl_dgmkt_campaign_ext.model';

export class DgMktCampaignExtensionContainerModel extends BaseContainerModel {
  bl_dgmkt_campaign_ext: bl_dgmkt_campaign_ext_RowClass =
    new bl_dgmkt_campaign_ext_RowClass();
}
